import { twMerge } from 'tailwind-merge'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { api, api_delete } from '../services/api.service'

import Confirm from '../components/confirm'
import Loading from '../components/loading'
import PageHeader from '../components/page-header'
import Table from '../components/table'

import { style } from '../style'

export default function AdminUsers() {
    const navigate = useNavigate()
    const [users, setUsers] = useState(null)
    const [deleteId, setDeleteId] = useState()

    useEffect(() => {
        api(`${process.env.REACT_APP_API_URL}/admin/user`).then((x) => setUsers(x))
    }, [])

    function deleteConfirm() {
        api_delete(`${process.env.REACT_APP_API_URL}/admin/user/${deleteId}`).then((x) => {
            api(`${process.env.REACT_APP_API_URL}/admin/user`)
                .then((x) => setUsers(x))
                .then((x) => setDeleteId(null))
        })
    }

    if (!users) return <Loading></Loading>

    return (
        <>
            <Confirm open={!!deleteId} cancel={() => setDeleteId(false)} confirm={() => deleteConfirm(deleteId)}></Confirm>

            <PageHeader
                headline={'Users'}
                actions={
                    <button className={twMerge(style.button.classname, style.button._secondary.classname)} onClick={() => navigate('/admin/manage-user/new')}>
                        Add User
                    </button>
                }
            ></PageHeader>

            <div className='flex'>
                <div className='w-full max-w-5xl pb-20 mx-auto my-10 2xl:max-w-6xl'>
                    <div>
                        <Table
                            exportColumns={['Name', 'Last Name', 'Email', 'Subscription']}
                            exportData={users.map((x) => {
                                return {
                                    name: x.name,
                                    lastName: x.lastName,
                                    email: x.email,
                                    subscription: x.subscriptionType,
                                }
                            })}
                            data={users.map((x) => {
                                const getSubscriptionDisplay = (type) => {
                                    switch (type) {
                                        case 'standard_premium':
                                            return 'Plus'
                                        case 'family_premium':
                                            return 'Family Plus'
                                        default:
                                            return 'Standard'
                                    }
                                }

                                return {
                                    ...x,
                                    subscriptionDisplay: getSubscriptionDisplay(x.subscriptionType),
                                    edit: (
                                        <span className='underline cursor-pointer' onClick={() => navigate(`/admin/manage-user/${x._id}`)}>
                                            Edit
                                        </span>
                                    ),
                                    deleteCell: (
                                        <span className='underline cursor-pointer' onClick={() => setDeleteId(x._id)}>
                                            Delete
                                        </span>
                                    ),
                                }
                            })}
                            columns={[
                                { Header: 'Name', accessor: 'name' },
                                { Header: 'Last Name', accessor: 'lastName' },
                                {
                                    Header: 'Email',
                                    accessor: 'email',
                                },
                                {
                                    Header: 'Subscription',
                                    accessor: 'subscriptionDisplay',
                                },
                                {
                                    Header: 'Edit',
                                    accessor: 'edit',
                                },
                                {
                                    Header: 'Delete',
                                    accessor: 'deleteCell',
                                },
                            ]}
                        ></Table>
                    </div>
                </div>
            </div>
        </>
    )
}
